import React from 'react'
import { Stack, Tooltip, Badge } from '@mui/material'
import WbButton from '../../components/common/WbButton'
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';
import paths from '../../routes/paths';
import ChatIcon from '@mui/icons-material/Chat';

export default function ConversationCard({ conversation }) {

  const navigate = useNavigate();
  // Helper function to get card color based on zone
  const getZoneClass = (zone) => {
    switch(zone?.toUpperCase()) {
      //case 'BLUE': return 'seagreen-card';
      //case 'GREEN': return 'green-card';
      //case 'ORANGE': return 'yellow-card';
      case 'RED': return 'red-card';
      default: return 'green-card';
    }
  };

  // Helper function for date formatting (converts UTC to local browser datetime)
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const utcDate = new Date(dateString);
    if (!(utcDate instanceof Date) || isNaN(utcDate)) return '';
    // Convert to local browser datetime
    const localDate = new Date(utcDate.getTime() + (utcDate.getTimezoneOffset() * 60000 * -1));
    // Format: July 17, 2025 at 12:11 PM
    const datePart = new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(localDate);
    const timePart = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(localDate);
    return `${datePart} at ${timePart}`;
  };

  const handleOpenConversation = () => {
    navigate(paths.startConversation, {
      state: {
        conversationId: conversation.conversationId,
        title: conversation.conversationTitle,
        staffName: conversation.responderName,
        isConversationClosed: conversation.isConversationClosed,
      }
    });
  };


  return (
    // <div className={`conversation-card ${getZoneClass(conversation.zone)}`}>
    <div className="conversation-card" style={{ backgroundColor: !conversation.isConversationClosed ? '#C5EEFF' : '#F3EDCD'}}>      
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 2, md: 0 }} justifyContent="space-between" alignItems={{ xs: "flex-start", sm: "center", md: "center" }}>
        <div className="conversation-card-header">
          <h2>{conversation.conversationTitle}</h2>
          <p>Created on: {formatDate(conversation.conversationStartDate)}</p>
          <p>Last updated: {formatDate(conversation.conversationModifiedDate)}</p>
          <p>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <PersonIcon sx={{fontSize: '20px !important'}}/>                           
              <span>{conversation.responderName}</span>
            </Stack>
          </p>
        </div>
        <div className="conversation-card-actions">
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={0.5} alignItems="center" justifyContent={{xs: "center", sm: "flex-end"}}>
            {/* Staff replies this pupil has not read.
                This counted every message in the thread against every message flagged seen, so a
                pupil's own messages raised it, and so did internal notes - which they cannot see at
                all. The tooltip says "New Reply", so a child was told replies were waiting when
                staff had written notes about them and answered nothing. On a tool a child uses to
                ask an adult for help, that is the wrong way round to be wrong. */}
            {conversation.studentUnseenMessages > 0 && (
              <Tooltip title="New Reply" arrow>
                <div className="unseen-message-indicator">
                  <Badge badgeContent={conversation.studentUnseenMessages} color="secondary">
                    <ChatIcon />
                  </Badge>
                </div>
              </Tooltip>
            )}            
            {/* <WbButton 
              CustomButtonText={conversation.isConversationClosed ? 'Closed' : 'View Conversation'}
              onClick={!conversation.isConversationClosed ? handleOpenConversation : undefined}
              style={{
                backgroundColor: conversation.isConversationClosed ? '#CD4239' : '#007A7A',
                border: 'none',                
                cursor: !conversation.isConversationClosed ? 'pointer' : 'default',
                fontSize: '14px',
              }}
            /> */}

            <WbButton 
              CustomButtonText='View Conversation'
              onClick={handleOpenConversation}
              style={{
                backgroundColor: conversation.isConversationClosed ? '#CD4239' : '#007A7A',
                border: 'none',                
                cursor: 'pointer',
                fontSize: '14px',
              }}
            />
          </Stack>
        </div>
      </Stack>
    </div>
  )
}
